/** @jsx jsx */
import React, { Fragment } from 'react'
import { jsx } from 'theme-ui'

import Container from '../components/Container'

import Hero from '../components//blocks/Hero'
import ProductList from '../components/blocks/ProductList'
import SideBySide from '../components/blocks/SideBySide'
import LifeStyleProduct from '../components/blocks/LifestyleProduct'
import TextSection from '../components/blocks/TextSection'
import CtaGrid from '../components/blocks/CtaGrid'
import ReviewCarousel from '../components/blocks/ReviewCarousel'
import { Space } from '../components/shared/index'

import ProductHero from '../components/blocks/ProductHero'

import LPButtonComponent from '../components/blocks/LPButtonComponent'
import CarouselContainer from '../components/blocks/CarouselContainer'

export const GenerateBlock = ({ block, containerProps, ...rest }) => {
  const { __typename } = block

  if (__typename === 'ContentfulProductHeroComponent') {
    return (
      <Container fullWidthMobile {...containerProps} {...rest}>
        <ProductHero {...block} />
      </Container>
    )
  }

  if (__typename === 'ContentfulActionButtonComponent') {
    return <LPButtonComponent {...block} {...rest} />
  }

  if (__typename === 'ContentfulHeroComponent') {
    return <Hero {...block} {...rest} />
  }
  if (__typename === 'ContentfulProductListComponent') {
    if (
      !block.collection ||
      !block.collection.products ||
      block.collection.products.length === 0
    )
      return <Fragment />
    return (
      <Container sx={{ px: 0 }} {...containerProps} fullWidthMobile {...rest}>
        <ProductList {...block} />
      </Container>
    )
  }

  if (__typename === 'ContentfulSideBySideComponent') {
    return (
      <Container fullWidthMobile {...containerProps} {...rest}>
        <SideBySide {...block.sideBySide} />
      </Container>
    )
  }
  if (__typename === 'ContentfulLifestyleProductComponent') {
    return (
      <Container {...containerProps} {...rest}>
        <LifeStyleProduct {...block} />
      </Container>
    )
  }
  if (__typename === 'ContentfulTextSectionComponent') {
    return (
      <Container {...containerProps} {...rest}>
        <TextSection {...block} />
      </Container>
    )
  }
  if (__typename === 'ContentfulCtaGridComponent') {
    return (
      <Container {...containerProps} {...rest}>
        <CtaGrid {...block} />
      </Container>
    )
  }
  if (__typename === 'ContentfulReviewCarouselComponent') {
    return (
      <Container
        fullWidthMobile
        sx={{ padding: 0 }}
        {...containerProps}
        {...rest}
      >
        <ReviewCarousel {...block} />
      </Container>
    )
  }
  if (__typename === 'ContentfulCarouselContainer') {
    return (
      <Container fullWidthMobile sx={{ padding: 0 }} {...containerProps}>
        <CarouselContainer {...block} />
      </Container>
    )
  }
  if (__typename === 'ContentfulSpaceComponent') {
    return (
      <Container
        fullWdithMobile
        fullWidth
        {...containerProps}
        sx={{
          px: '8em',
        }}
      >
        <Space block {...block} />
      </Container>
    )
  }
  return <Fragment />
}
